<template>
  <div class="social-stack">
    <a
      v-for="p in providers"
      :key="p.id"
      :href="oauthUrl(p.id)"
      class="social-btn"
      :class="p.id"
      @click.prevent="onSocialClick(p.id)"
    >
      <span
        class="logo"
        aria-hidden="true"
        ><component :is="p.icon"
      /></span>
      <span class="lbl">{{ t(labelKeyPrefix + '_' + p.id) }}</span>
    </a>
  </div>
</template>

<script>
import { i18nMixin, oauthUrl } from '../helpers';
import IconApple from '../../icons/IconApple.vue';
import IconGoogleG from '../../icons/IconGoogleG.vue';
import IconFacebook from '../../icons/IconFacebook.vue';
import { stashAnalyticsContext } from '../../../../analytics/ga4';

const PROVIDERS = [
  { id: 'apple', icon: IconApple },
  { id: 'google', icon: IconGoogleG },
  { id: 'facebook', icon: IconFacebook },
];

export default {
  name: 'SocialButtons',
  mixins: [i18nMixin],
  props: {
    labelKeyPrefix: { type: String, default: 'social' },
    intent: { type: String, default: 'register' }, // register | login
    ctaLocation: { type: String, default: 'unknown' },
  },
  inject: {
    signupCtaLocation: { default: null },
  },
  data() {
    return { providers: PROVIDERS };
  },
  computed: {
    resolvedCtaLocation() {
      if (this.ctaLocation && this.ctaLocation !== 'unknown') {
        return this.ctaLocation;
      }
      if (typeof this.signupCtaLocation === 'function') {
        return this.signupCtaLocation() || 'unknown';
      }
      return 'unknown';
    },
  },
  methods: {
    oauthUrl,
    async onSocialClick(provider) {
      const href = this.oauthUrl(provider);
      try {
        await stashAnalyticsContext({
          cta_location: this.resolvedCtaLocation,
          method: provider,
        });
      } catch (e) {
        // proceed to OAuth even if stash fails
      }
      if (this.intent === 'login') {
        // login event fires after successful callback via flash meta if needed;
        // here we only stash context for possible new social SOI.
      }
      window.location.href = href;
    },
  },
};
</script>
